import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, useMemo } from 'react';
import cn from 'classnames';
import { useDevice } from '../../providers/Device';
import { useIsInBottomSheet } from '../../providers/IsInBottomSheetProvider';
import { getTestIds } from '../../utils/TestIds';
import styles from './GridItem.module.scss';
export const GetGridItemTID = (parentTestId)=>getTestIds(parentTestId);
export const GridItem = /*#__PURE__*/ forwardRef(function GridItem(_0, _1) {
    let _ref = [
        _0,
        _1
    ], [_ref1, ..._rest] = _ref, { className, span, justify, collapseOnMobile, hideOnMobile, testId } = _ref1, rest = _object_without_properties(_ref1, [
        "className",
        "span",
        "justify",
        "collapseOnMobile",
        "hideOnMobile",
        "testId"
    ]), [ref] = _rest;
    const { isMobileDevice } = useDevice();
    const isInBottomSheet = useIsInBottomSheet();
    const { GridItemTID } = useMemo(()=>GetGridItemTID(testId), [
        testId
    ]);
    const isMobileContext = isMobileDevice || isInBottomSheet;
    const effectiveSpan = collapseOnMobile && isMobileDevice ? 12 : span;
    if (hideOnMobile && isMobileContext) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        ref: ref,
        className: cn(styles.root, className),
        "data-testid": GridItemTID.Root()
    }, rest), {
        style: {
            '--cellWidth': effectiveSpan,
            justifySelf: justify
        }
    }));
});
